// extracted by mini-css-extract-plugin
export default {"pagination":"_63f3L","page-link":"NAS+K","page-item":"yu6m7","active":"GynZ2","disabled":"NSVgg","pagination-lg":"WPYsg","pagination-sm":"_22jzZ","page-link-next":"MtVE9"};